import { gql } from '@parkchirp/api-client';

export const GET_FACILITY = gql`
  query getFacility(
        $facilityId: String!
        $tenantSubscriptionId: String
    ) {
    getFacility(
        facility_id: $facilityId
        tenantSubscriptionId: $tenantSubscriptionId
    ) {
        id
        facility_name
        facility_number
        timezone
        organization_id
    }
  }
`;

export const GET_FACILITY_V2 = gql`
    query getFacility(
        $facilityId: String!,
        $withSublots: Boolean,
        $tenantSubscriptionId: String
    ) {
        getFacility(
            facilityId: $facilityId,
            withSublots: $withSublots,
            tenantSubscriptionId: $tenantSubscriptionId
        ) {
            id
            facilityName
            facilityNumber
            wordpressPostId
            organizationId
            integration
            timezone
            accessSystemCredentials
            facilitySettings {
              usesDefaultRates
              maxActiveVehicles
              minActiveVehicles
              enableReservedSpaceInventory
              approvedDriversEnabled
              maxApprovedDrivers
            }
            sublots {
                id
                name
                primaryLot
            }
        }
    }
`;

export const GET_FACILITIES_V2 = gql`
  query listFacilities(
    $limit: Int!
    $offset: Int!
    $order: SortOrder
    $filters: [Filter]
    $queryContext: FacilityQueryContextEnum
  ) {
    listFacilities(
      limit: $limit
      offset: $offset
      order: $order
      filters: $filters
      queryContext: $queryContext
    ) {
        id,
        facilityName,
        facilityNumber,
        timezone,
        organizationId,
        contractType,
        timezone,
        onlineStartDate,
        integration,
        onlineEndDate,
        cityId,
        accessSystemCredentials
        organizationSettings {
          name
          requireProductAndRateCodes
        }
        facilitySettings {
          usesDefaultRates
          maxActiveVehicles
          minActiveVehicles
        }
    }
  }
`;

export const GET_FACILITY_AREAS_BRANCHES_DISTRICTS_V2 = gql`
  query listFacilityAreasBranchesDistricts {
    listFacilityAreasBranchesDistricts {
      facilityAreas {
        id
        name
        code
      }
      facilityBranches {
        id
        name
        code
      }
      facilityDistricts {
        id
        name
        code
      }
    }
  }
`;

export const GET_FACILITY_SETTINGS_REPORT = gql`
  query getFacilitySettingsReport(
    $facilityId: String!,
    $reportType: ReportType!
  ) {
    getFacilitySettingsReport(
        facilityId: $facilityId,
        reportType: $reportType
    ) {
      url
    }
  }
`;

export const GET_ORGANIZATION_SETTINGS_BY_FACILITY_ID = gql`
    query getOrganizationSettingsByFacilityId($facilityId: String!) {
        getOrganizationSettingsByFacilityId(facilityId: $facilityId) {
            prohibitPreviousParkingPeriodParkers
            isParkerTypeRequired
        }
    }
`;

export const LIST_TAX_TABLE_CITIES_BY_ORGANIZATION_ID_BY_CITIES = gql`
    query listTaxTableCitiesByOrganizationIdByCities(
        $organizationId: Int!,
        $filters: [Filter],
        $order: [SortOrder],
        $limit: Int,
        $offset: Int,
      ) {
        listTaxTableCitiesByOrganizationIdByCities(
          organizationId: $organizationId,
          filters: $filters,
          order: $order,
          limit: $limit,
          offset: $offset
        ) {
            id
            name
            state
            active
            timezone
            organizationId
      }
    }
`;
